import * as mock from "./mock";
import { create } from "../UtilsOld";

const Service = {};
const option = [
    /**
     * 添加天合之星
     * @param { Number } chengguoId 成果 ID
     */
    ["list", "/list", "get", true, "/ns/star"],
    /**
     * 添加天合之星
     * @param { Number } chengguoId 成果 ID
     */
    ["add", "/add", "post", true, "/ns/star"],
    /**
     * 成果详情
     * @param { Number } chengguoId 成果 ID
     */
    ["info", "/info", "get", true, "/ns/star"],
    /**
     * 修改
     */
    ["put", "/put", "put", true, "/ns/star"],
    /**
     * 取消
     */
    ["del", "/del", "put", true, "/ns/star"],
    /**
     * 启用
     */
    ["open", "/open", "put", true, "/ns/star"],
    /**
     * 发布
     */
    ["build", "/build", "put", true, "/ns/star"],
    /**
     * 发布
     */
    ["buildAgain", "/buildAgain", "put", true, "/ns/star"],
]

create(option, Service, mock)

export default {
    Service,
    option
}
